'use client';

import { ReactNode, useEffect } from 'react';
import { useAuthStore } from '@/hooks/auth/useAuthStore';

interface StoreProviderProps {
  children: ReactNode;
}

export const StoreProvider = ({ children }: StoreProviderProps) => {
  const hydrate = useAuthStore((state) => state.hydrate);

  useEffect(() => {
    hydrate();
  }, [hydrate]);

  return <>{children}</>;
};